// src/api/axios.js
import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor: attach token
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Response Interceptor: handle expired session
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      ["token", "user", "areaId", "selected_area", "agencyId", "selected_agency"].forEach(
        (key) => localStorage.removeItem(key)
      );
      window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export default instance;
